import { useEffect, useState } from "react";
import { portalApi } from "./portalApi";
import { Modal } from "../components/UI";
import { RichText } from "../components/RichText";
import { FileHeart, ExternalLink, CheckCircle2 } from "lucide-react";

/** Handouts a clinician approved and shared to this client's portal. */
export function PortalHandouts() {
  const [rows, setRows] = useState([]);
  const [open, setOpen] = useState(null);
  const load = () => portalApi.get("/portal/handouts").then((r) => setRows(r.data)).catch(() => setRows([]));
  useEffect(() => { load(); }, []);
  const view = async (h) => {
    setOpen(h);
    if (!h.viewed_at) { try { await portalApi.post(`/portal/handouts/${h.id}/view`); load(); } catch { /* view log best-effort */ } }
  };
  if (!rows.length) return null;
  return (
    <div data-testid="portal-handouts">
      <h3 className="mb-2 font-heading text-sm font-bold text-[#3E2723]">From your care team</h3>
      <div className="grid gap-3 sm:grid-cols-2">
        {rows.map((h) => (
          <button key={h.id} type="button" data-testid={`portal-handout-${h.id}`} onClick={() => view(h)}
            className="flex items-start gap-3 rounded-2xl border border-[#EFEBE0] bg-white p-4 text-left transition-shadow hover:shadow-md">
            <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-[#F5F2EB] text-[#7B6157]"><FileHeart size={18} /></span>
            <span className="min-w-0 flex-1">
              <span className="block font-heading text-sm font-bold text-[#3E2723]">{h.title}</span>
              <span className="mt-0.5 block text-xs text-[#7B6157]">Shared by {h.approved_by_name}</span>
              {h.viewed_at && <span className="mt-1 inline-flex items-center gap-1 rounded-full bg-[#2E7D32] px-2 py-0.5 text-[10px] font-bold text-white"><CheckCircle2 size={10} /> Read</span>}
            </span>
          </button>
        ))}
      </div>
      <Modal open={!!open} onClose={() => setOpen(null)} title={open?.title || ""} wide>
        {open && (
          <div className="space-y-3" data-testid="portal-handout-view">
            <RichText html={open.body} testId="portal-handout-body" className="text-[#5D4037]" />
            {(open.links || []).length > 0 && <div className="space-y-2">{open.links.map((l) => (
              <a key={l.url} href={l.url} target="_blank" rel="noreferrer" className="flex items-center gap-2 rounded-xl border border-[#EFEBE0] bg-white px-3 py-2 text-sm text-[#4E342E] hover:bg-[#F5F2EB]"><ExternalLink size={13} /> {l.label}</a>
            ))}</div>}
            <p className="text-[10px] text-[#84675B]">Approved by {open.approved_by_name}. Education only, not medical advice. If you are in crisis, call or text 988, or call 911.</p>
          </div>
        )}
      </Modal>
    </div>
  );
}
